var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"equipment-tab"},[_c('div',{staticClass:"row"},[_c('GearPreview',{attrs:{"equipment":_vm.equipment},on:{"update":_vm.equipmentChanged}})],1),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12"},[_c('EquipmentCost',{attrs:{"equipment":_vm.equipment,"prices":_vm.itemPrices}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a69af4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/EquipmentTab.vue
// module id = null
// module chunks = 